import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useReduxAuth} from './useReduxAuth'

export function Logout() {
  const {logout} = useReduxAuth()
  useEffect(() => {
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/login' />
    </Routes>
  )
}
